<template>
    <div class="servicos-encerrados">
        <img src="../assets/logo_dalcatech_branco.png" alt="Logo Dalcatech" class="logo">
        <div class="conteudo">
            <h2>Página Não Encontrada</h2>
            <p>O serviço que você procura não foi encontrado.</p>
            <p class="submensagem">Entre em contato para mais informações.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PaginaNaoEncontradaView",
}
</script>

<style scoped>
.servicos-encerrados {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--primaryDark_azul, #1a1a2e);
}

.servicos-encerrados .logo {
    width: 150px;
    margin-bottom: 24px;
}

.conteudo {
    text-align: center;
    padding: 32px;
    color: white;
}

.conteudo>h2 {
    font-size: 1.rem;
    margin-bottom: 16px;
}

.conteudo>p {
    font-size: 1.1rem;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 8px;
}

.conteudo>.submensagem {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.55);
}
</style>
